import { render } from "./IndependentIncome.vue?vue&type=template&id=881319ac"
import script from "./IndependentIncome.vue?vue&type=script&lang=js"
export * from "./IndependentIncome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__